import React, { useState } from 'react';
import Header from './components/Header';
import CompressionForm from './components/CompressionForm';
import ResultDisplay from './components/ResultDisplay';
import './styles/App.css';

function App() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleResult = (data) => {
    setResult(data);
    setError(null);
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setResult(null);
  };

  const handleLoading = (isLoading) => {
    setLoading(isLoading);
  };

  const clearResults = () => {
    setResult(null);
    setError(null);
  };

  return (
    <div className="App">
      <Header />
      <main className="main-container">
        <div className="content-wrapper">
          <CompressionForm 
            onResult={handleResult}
            onError={handleError}
            onLoading={handleLoading}
            loading={loading}
            onClear={clearResults}
          />
          
          {error && (
            <div className="error-container">
              <i className="fas fa-exclamation-triangle"></i>
              <p>{error}</p>
            </div>
          )}
          
          {result && (
            <ResultDisplay 
              result={result} 
              onClear={clearResults}
            />
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
